import { getBaseUrl } from 'utils/url';

// Host images
import introBackground from "assets/images/Host/Backgrounds/Intro.jpg";
import roundIntroBackground from "assets/images/Host/Backgrounds/RoundIntro.jpg";
import introTitleScreen from "assets/images/Host/Content/TitleScreen.jpg";
import bigScreenBg from "assets/images/Host/Content/BigScreenBG.jpg";
import revealBackgroundBlue4 from "assets/images/Host/Backgrounds/RevealBlue4.jpg";
import revealBackgroundBlue3 from "assets/images/Host/Backgrounds/RevealBlue3.jpg";
import revealBackgroundBlue2 from "assets/images/Host/Backgrounds/RevealBlue2.jpg";
import revealBackgroundRed4 from "assets/images/Host/Backgrounds/RevealRed4.jpg";
import revealBackgroundRed3 from "assets/images/Host/Backgrounds/RevealRed3.jpg";
import revealBackgroundRed2 from "assets/images/Host/Backgrounds/RevealRed2.jpg";
import revealLeftFlash from "assets/images/Host/Content/RevealFlashLeft.png";
import revealRightFlash from "assets/images/Host/Content/RevealFlashRight.png";
import answerBackground from "assets/images/Host/Content/AnswerBox.jpg";
import droppedAnswer from "assets/images/Host/Content/DroppedAnswer.jpg";
import questionsBackground4 from "assets/images/Host/Backgrounds/Questions4.jpg";
import questionsBackground3 from "assets/images/Host/Backgrounds/Questions3.jpg";
import questionsBackground2 from "assets/images/Host/Backgrounds/Questions2.jpg";
import hostSplash from "assets/images/Host/Backgrounds/Splash.jpg";
import gameOverBackground from "assets/images/Host/Backgrounds/GameOver.jpg";
import gameOverForeground from "assets/images/Host/Content/GameOverOverlay.png";
import gameOverPodium from "assets/images/Host/Content/GameOverPodium.png";
import revealDropShaft_2_1 from "assets/images/Host/Content/DropShafts/DropShaft_2_1.png";
import revealDropShaft_2_2 from "assets/images/Host/Content/DropShafts/DropShaft_2_2.png";
import revealDropShaft_3_1 from "assets/images/Host/Content/DropShafts/DropShaft_3_1.png";
import revealDropShaft_3_2 from "assets/images/Host/Content/DropShafts/DropShaft_3_2.png";
import revealDropShaft_3_3 from "assets/images/Host/Content/DropShafts/DropShaft_3_3.png";
import revealDropShaft_4_1 from "assets/images/Host/Content/DropShafts/DropShaft_4_1.png";
import revealDropShaft_4_2 from "assets/images/Host/Content/DropShafts/DropShaft_4_2.png";
import revealDropShaft_4_3 from "assets/images/Host/Content/DropShafts/DropShaft_4_3.png";
import revealDropShaft_4_4 from "assets/images/Host/Content/DropShafts/DropShaft_4_4.png";

// Client images
import clientBackground from "assets/images/Client/Background.jpg";
import clientSplash from "assets/images/Client/Cover.jpg";

// Shared images
import mutedIcon from "assets/images/Shared/lobby_muted.png";
import unmutedIcon from "assets/images/Shared/lobby_unmuted.png";
import fullscreenIcon from "assets/images/Shared/lobby_fullscreen.png";
import menuIcon from "assets/images/Shared/lobby_menu.png";
import helpIcon from "assets/images/Shared/lobby_help.png";
import GCLogoWhite from "assets/images/Shared/gc_logo_white.png";
import GCLogoBlack from "assets/images/Shared/gc_logo_black.png";
import mdmdLogo from "assets/images/Client/MDMD-Logo.png";

// Videos
import introVideo from "assets/videos/Intro.mp4";
import introVideoFallbackAudio from "assets/videos/fallback/audio/Intro_Fallback_Audio.mp3";
import gameStartVideo from "assets/videos/StartGame.mp4";
import startGameVideoFallbackAudio from "assets/videos/fallback/audio/StartGame_Fallback_Audio.mp3";

export const IMAGES = {
    HOST: {
        revealBackgroundBlue4,
        revealBackgroundBlue3,
        revealBackgroundBlue2,
        revealBackgroundRed4,
        revealBackgroundRed3,
        revealBackgroundRed2,
        revealLeftFlash,
        revealRightFlash,
        answerBackground,
        droppedAnswer,
        questionsBackground4,
        questionsBackground3,
        questionsBackground2,
        hostSplash,
        gameOverBackground,
        gameOverForeground,
        gameOverPodium,
        introBackground,
        roundIntroBackground,
        introTitleScreen,
        revealDropShaft_2_1,
        revealDropShaft_2_2,
        revealDropShaft_3_1,
        revealDropShaft_3_2,
        revealDropShaft_3_3,
        revealDropShaft_4_1,
        revealDropShaft_4_2,
        revealDropShaft_4_3,
        revealDropShaft_4_4,
        bigScreenBg,
    },
    CLIENT: {
        clientBackground,
        clientSplash,
        mdmdLogo,
    },
    SHARED: {
        mutedIcon,
        unmutedIcon,
        fullscreenIcon,
        menuIcon,
        helpIcon,
        GCLogoWhite,
        GCLogoBlack,
    },
};

export const VIDEOS = {
    INTRO: {
        src: introVideo,
        fallbackAudio: {
            src: introVideoFallbackAudio,
            volume: 1.0,
        },
        posterImage: IMAGES.HOST.hostSplash,
    },
    GAME_START: {
        src: gameStartVideo,
        fallbackAudio: {
            src: startGameVideoFallbackAudio,
            volume: 1.0,
        },
        posterImage: IMAGES.HOST.introBackground,
    },
}

export const FONTS = [
    { font: "ITC Gothic Bold", path: `${getBaseUrl()}/Assets/ITCAvantGardeGothicLTCondensedBold.ttf` },
];

export const GAME_ID = "mdmd";

export const GAME_STATES = {
    LOADING: "loading",
    INTRO_VIDEO: "intro_video",
    START_MENU: "start_menu",
    GAME_START_VIDEO: "game_start_video",
    ROUND_INTRO: "round_intro",
    CATEGORY_SELECT: "category_select",
    ASKING_QUESTION: "asking_question",
    ANSWERING: "answering",
    STACKING_CASH: "stacking_cash",
    REVEAL: "reveal",
    GAME_OVER: "game_over",
};

export const NON_RESTARTABLE_STATES = [
    GAME_STATES.LOADING,
    GAME_STATES.INTRO_VIDEO,
    GAME_STATES.START_MENU,
    GAME_STATES.GAME_OVER,
];

export const MESSAGES = {
    // Messages sent from client to server
    TO_SERVER: {
        INTRO_VIDEO_COMPLETE: "intro_video_complete",
        PLAYER_START_GAME: "player_start_game",
        GAME_START_VIDEO_COMPLETE: "game_start_video_complete",
        ROUND_INTRO_COMPLETE: "round_intro_complete",
        SELECT_CATEGORY: "select_category",
        QUESTION_ASKING_COMPLETE: "question_asking_complete",
        PLACE_MONEY: "place_money",
        LOCK_IN: "lock_in",
        STACKING_CASH_COMPLETE: "stacking_cash_complete",
        REVEAL_COMPLETE: "reveal_complete",
        CALL_END_GAME: "call_end_game",
        HOST_LOADED: "host_loaded",
        SKIP_VIDEO: "skip_video",

        //built-in
        CHANGE_GAME: "change_game",
        MUTE_MUSIC: "mute_game_music",
        MUTE_SFX: "mute_game_sfx",
        ANIMATE_POTATO: "animate_potato"

    },
    // Messages sent from server to client
    TO_CLIENTS: {
        CHANGE_GAME: "change_game",
        ANIMATE_POTATO: "animate_potato"
    }
};